import { render, staticRenderFns } from "./EcommerceAddProductMediaWithChunk.vue?vue&type=template&id=494d4e9a&scoped=true&"
import script from "./EcommerceAddProductMediaWithChunk.vue?vue&type=script&lang=js&"
export * from "./EcommerceAddProductMediaWithChunk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494d4e9a",
  null
  
)

export default component.exports